import {inject, Injectable} from '@angular/core';
import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from "rxjs/operators";
import {ErrorService} from "../services/error/error.service";
import {NotificationsService} from "../services/notifications/notifications.service";

/** Set this context token to true to suppress global error handling for a request. */
export const SUPPRESS_ERROR_HANDLING = new HttpContextToken<boolean>(() => false);

/**
 * Interceptor for HTTP Errors
 */
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private errorService = inject(ErrorService);
  private notificationService = inject(NotificationsService);


  /**
   * Intercept on any HTTP Error code
   * @param request an HTTP Request
   * @param next an HTTP Handler
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (request.context.get(SUPPRESS_ERROR_HANDLING)) {
            return throwError(() => error);
          }

          let errorMsg = '';
          if (error.error instanceof ErrorEvent) {
            errorMsg = `Error: ${error.error.message}`;
          } else {
            errorMsg = `Error Code: ${error.status}, Message: ${error.message}`;
          }

          this.errorService.triggerError(error);
          // Original HttpErrorResponse weitergeben, damit Aufrufer den Response-Body
          // (z.B. { message: "..." }) auswerten und anzeigen können.
          return throwError(() => error);
        })
      )
  }
}
